import { FC, useState } from "react";
import { DrawerWrapper, SidebarWrapper } from "./Sidebar.style";
import { Box } from "@mui/material";
import { GoSidebarExpand, GoSidebarCollapse } from "react-icons/go";
import { InputField, TreeView } from "components";

type IMobileSidebarProps = {
  setSearch: (search: string) => void;
  search: string;
};

export const MobileSidebar: FC<IMobileSidebarProps> = ({
  setSearch,
  search,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <SidebarWrapper className="sidebar-container">
        <Box className="menu-div">
          <Box className="icon">
            {<GoSidebarCollapse onClick={toggleDrawer} />}
          </Box>
          <Box className="search-field">
            <InputField
              search={search}
              placeholder="Search here..."
              onClick={toggleDrawer}
            />
          </Box>
        </Box>
      </SidebarWrapper>
      <DrawerWrapper
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer}
        BackdropProps={{ invisible: true }}
      >
        <SidebarWrapper className="drawer-container">
          <Box className="menu-div">
            <Box className="icon">
              {<GoSidebarExpand onClick={toggleDrawer} />}
            </Box>
            <Box className="search-field">
              <InputField
                focused
                placeholder="Search here..."
                search={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Box>
          </Box>
          <TreeView search={search} toggleDrawer={toggleDrawer} />
        </SidebarWrapper>
      </DrawerWrapper>
    </>
  );
};
